/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignsShowPathParams, CampaignsShowResponse } from '../types/CampaignsShow'

/**
 * GET /campaigns/:campaign
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::show
 */
export async function campaignsShow(
	campaign: CampaignsShowPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignsShowResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}`, config)
}
